import { useState, useEffect } from "react";
import apiClient from "../api/apiClient";

export interface SELStory {
  documentId: string;
  name: string;
  level: string;
  focusSkills: string | null;
  theme: string | null;
  plot: string | null;
  ageGroup: string;
  estimatedTime: string;
  order: number;
}

export interface SELCompetency {
  selCompetency: string;
  stories: SELStory[];
}

export interface SELStoriesResponse {
  success: boolean;
  meta: {
    scope: string;
    schoolId: string;
    totalCompetencies: number;
  };
  data: SELCompetency[];
}

interface UseSELStoriesProps {
  schoolHash: string;
  grade: string;
  enabled?: boolean;
}

export const useSELStories = ({ schoolHash, grade, enabled = true }: UseSELStoriesProps) => {
  const [data, setData] = useState<SELStoriesResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStories = async () => {
    if (!schoolHash || !grade || !enabled) return;

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(`dashboard/sel/${schoolHash}/${grade}`);
      setData(response.data);
    } catch (err: any) {
      setError(err.message || "Failed to fetch SEL stories");
      console.error("Error fetching SEL stories:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStories();
  }, [schoolHash, enabled]);

  return {
    data,
    loading,
    error,
    refetch: fetchStories,
  };
};
